const invalidCPF = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
];

const invalidCNPJ = [
  '00000000000000',
  '11111111111111',
  '22222222222222',
  '33333333333333',
  '44444444444444',
  '55555555555555',
  '66666666666666',
  '77777777777777',
  '88888888888888',
  '99999999999999'
];

export const isCpf = (cpf) => {
  if (!cpf) { return false; }

  cpf = cpf.replace(/\D/g, '');

  if (cpf.length !== 11 || invalidCPF.includes(cpf)) { return false; }

  const numberValue = cpf.slice(0, -2);
  const dv1 = cpf[9];
  const dv2 = cpf[10];

  if (checkDV(numberValue, dv1, 'cpf') && checkDV(numberValue + dv1, dv2, 'cpf')) { return true; }

  return false;
};

export const isCNPJ = (cnpj) => {
  if (!cnpj) { return false; }

  cnpj = cnpj.replace(/\D/g, '');

  if (cnpj.length !== 14 || invalidCNPJ.includes(cnpj)) { return false; }

  const numberValue = cnpj.slice(0, -2);
  const dv1 = cnpj[12];
  const dv2 = cnpj[13];

  if (checkDV(numberValue, dv1, 'cnpj') && checkDV(numberValue + dv1, dv2, 'cnpj')) { return true; }

  return false;
};

const checkDV = (numberParam, dv, checkType) => {
  let check = null;
  let result = null;

  if (checkType === 'cpf') {
    check = numberParam
      .split('')
      .map((item, i) => {
        const res = item * (numberParam.length + 1 - i);
        return res;
      })
      .reduce((x, y) => {
        return x + y;
      });

    result = 11 - (check % 11);

    if (result === 10 || result === 11) {
      result = 0;
    }

  } else {
    check = numberParam
      .split('')
      .map((item, i) => {
        return ((i % 8) + 2) * parseInt(item, 10);
      })
      .reduce((x, y) => {
        return x + y;
      });

    result = check % 11;

    if (result < 2) {
      result = 0;
    } else {
      result = 11 - result;
    }
  }

  return result.toString() === dv;
};